import { Box, Container, Typography, Grid, Divider } from '@mui/material';

const info = [
  { label: '会社名', value: 'takoshiLabo株式会社' },
  { label: '設立', value: '2026年1月' },
  { label: '事業内容', value: 'SaaSプロダクト開発 / AI活用支援 / AIコンサルティング' },
];

export default function About() {
  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 10, textAlign: 'center' }}>
          <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 4, fontWeight: 700 }}>
            About
          </Typography>
          <Typography variant="h2" sx={{ mt: 2, fontSize: { xs: '2rem', md: '2.8rem' } }}>
            会社概要
          </Typography>
        </Box>

        <Grid container spacing={8} alignItems="flex-start">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
              AIで現場を変える、<br />小さくて強いチーム。
            </Typography>
            <Typography color="text.secondary" sx={{ lineHeight: 2, mb: 3 }}>
              takoshiLaboは、SaaS開発とAI活用に特化したITカンパニーです。
              最新の生成AI技術を現場のリアルな課題に結びつけ、スピーディーかつ実践的なソリューションを届けます。
            </Typography>
            <Typography color="text.secondary" sx={{ lineHeight: 2 }}>
              「現場にAIを届ける」をミッションに、中小企業から成長スタートアップまで、
              ビジネスの現場に根付くDXを支援します。
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ border: '1px solid rgba(255,255,255,0.08)', borderRadius: 3, overflow: 'hidden' }}>
              {info.map((item, i) => (
                <Box key={item.label}>
                  <Box sx={{ display: 'flex', py: 3, px: 4, gap: 4 }}>
                    <Typography color="text.secondary" sx={{ minWidth: 100, fontWeight: 600, fontSize: '0.9rem' }}>
                      {item.label}
                    </Typography>
                    <Typography sx={{ lineHeight: 1.7 }}>
                      {item.value}
                    </Typography>
                  </Box>
                  {i < info.length - 1 && <Divider sx={{ borderColor: 'rgba(255,255,255,0.06)' }} />}
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
